export const LOGIN_ROUTE = "/login"
export const MAIN_ROUTE = "/main"
export const NOTES_LIST_ROUTE="/notes"